import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { QuotationDraftFooterProps } from "models/propTypes/quotationPropTypes";
import { InvoiceFormTypes } from "models/formTypes";
import { HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { InvoiceWizardMoreActions } from "components/invoice";
import useQuotationPreview from "./usePreview";
import { useNavigate, useLocation } from "react-router-dom";
import { Portal } from "@mui/material";
import { useFormSubmitHelpers } from "components/common/wintForms";
//#endregion
import { useQuotesService } from "serviceHooks";
import { UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const QuotationDraftFooter: React.FC<QuotationDraftFooterProps> = (props) => {
  const quotesService = useQuotesService();
  const { quotation, wizardProps, form, isFormLoading } = props;

  const { submitForm, validateForm } = useFormSubmitHelpers();

  const footerMount = document.getElementById(HTMLConstants.EntityCreationLayoutFooterPortalId);

  const location = useLocation();
  const navigate = useNavigate();

  const onQuotationFormSubmit = (form: InvoiceFormTypes.Create) => {
    const quotationPost = quotesService.convertFormToAPIRequest(form);
    return quotesService.createOrUpdateQuotation(form.serialNumber, quotationPost);
  };

  const submitQuotation = async () => {
    return submitForm(form, onQuotationFormSubmit);
  };

  const reloadQuotation = (serialNumber: number) => {
    navigate(UrlHelper.formatPath(`/Quotation/${serialNumber}`), {
      replace: true,
      state: { background: location },
    });
  };

  const { showPreviewDialog } = useQuotationPreview();

  const onShowQuotationPreview = async () => {
    const isValid = await validateForm(form, TranslationKeys.Validations.FormContainsErrors);
    if (isValid) {
      const formValues = form.values;
      if (formValues) showPreviewDialog(props.quotation, formValues, reloadQuotation);
    }
  };

  return (
    <Portal container={footerMount}>
      <PageFooter
        actions={[
          {
            text: TranslationKeys.Common.FinalReview,
            onClick: onShowQuotationPreview,
            type: StyleEnums.DisplayType.Success,
          },
        ]}
        moreActions={
          <InvoiceWizardMoreActions
            createInvoiceHandler={submitQuotation}
            reloadInvoiceHandler={reloadQuotation}
            invoiceId={quotation?.serialNumber}
            isQuotation
            invoiceOwnerId={quotation?.ownerId}
          />
        }
        isFormValid={!isFormLoading}
        onBackButtonClick={
          wizardProps.currentStep ? () => wizardProps.goToStep(wizardProps.currentStep - 1) : undefined
        }
        onNextButtonClick={
          wizardProps.stepCount - 1 > wizardProps.currentStep
            ? () => wizardProps.goToStep(wizardProps.currentStep + 1)
            : undefined
        }
        className={cssExports.wizardFooter}
      />
    </Portal>
  );
};

export default QuotationDraftFooter;
